import axios from "axios";

// RevenueCat API configuration
const REVENUECAT_API_BASE_URL = "https://api.revenuecat.com/v2";
const REVENUECAT_PROJECT_ID = "4ec56b70"; // Your actual project ID
const REVENUECAT_OFFERING_ID = "ofrng6b6a867cbb"; // Updated offering ID from the new offering

// RevenueCat Web Purchase configuration - Environment aware
const REVENUECAT_WEB_PURCHASE_TOKEN = 
  process.env.NODE_ENV === "production"
    ? "jpgrofoixhhwiqky" // Production token
    : "svewmqjkgapexscz"; // Sandbox token for development/local

// Get API key from environment variables
const REVENUECAT_API_KEY = process.env.REACT_APP_REVENUECAT_API_KEY;

// Debug logging to check if API key is loaded
console.log("RevenueCat API Key loaded:", REVENUECAT_API_KEY ? "Yes" : "No");
console.log("RevenueCat API Key length:", REVENUECAT_API_KEY?.length || 0);

export interface RevenueCatProduct {
  product: {
    id: string;
    store_identifier: string;
    type: string;
    display_name: string;
    subscription?: {
      duration: string;
      grace_period_duration?: string;
      trial_duration?: string;
    };
    one_time?: {
      is_consumable: boolean;
    };
  };
  eligibility_criteria: string;
}

export interface RevenueCatPackage {
  id: string;
  lookup_key: string;
  display_name: string;
  position: number;
  products: {
    items: RevenueCatProduct[];
  };
}

export interface RevenueCatOffering {
  id: string;
  lookup_key: string;
  display_name: string;
  is_current: boolean;
  packages: {
    items: RevenueCatPackage[];
  };
}

export async function fetchRevenueCatOffering(): Promise<RevenueCatOffering> {
  try {
    if (!REVENUECAT_API_KEY) {
      throw new Error("RevenueCat API key is not configured. Please check your environment variables.");
    }

    console.log("Fetching RevenueCat offering...");
    console.log("Project ID:", REVENUECAT_PROJECT_ID);
    console.log("Offering ID:", REVENUECAT_OFFERING_ID);
    console.log("API Key starts with:", REVENUECAT_API_KEY?.substring(0, 10) + "...");
    
    const response = await axios.get(
      `${REVENUECAT_API_BASE_URL}/projects/${REVENUECAT_PROJECT_ID}/offerings/${REVENUECAT_OFFERING_ID}`,
      {
        headers: {
          "Authorization": `Bearer ${REVENUECAT_API_KEY}`,
          "Content-Type": "application/json",
        },
        params: {
          expand: ["package", "package.product"],
        },
      }
    );

    console.log("RevenueCat API response:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("Error fetching RevenueCat offering:", error);
    console.error("Error status:", error.response?.status);
    console.error("Error message:", error.response?.data);
    console.error("Request URL:", error.config?.url);
    console.error("Request headers:", error.config?.headers);
    throw error;
  }
}

// Helper function to create paywall URL with user ID
export function createRevenueCatPaywallUrl(userId: string): string {
  return `https://pay.rev.cat/${REVENUECAT_WEB_PURCHASE_TOKEN}/${userId}`;
} 